import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlipToggle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 11,
	height: 5,
	transform: "current",
	viewBox: "0 0 11 5",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0.5 0L5.5 5L10.5 0H0.5Z",
		fill: "#079E88"
	})]
});
const ForwardRef = forwardRef(SvgFlipToggle);
export { ForwardRef as ReactComponent };
